import { CircularProgress, Grid } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getSupplierInvoiceListApi } from '../../../redux/Supplier/action';
import { formatCurrency } from '../../../utility/helpers/displayHelper';
import SupplierInvoiceCards from './SupplierInvoiceCards';

function SupplierInvoiceTab({ supplierId }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const supplierInvoiceList = useSelector((state) => state?.supplier?.supplierInvoiceList?.data || []);
    const fetchSupplierInvoice = async () => {
        if (isLoading) return;
        try {
            setIsLoading(true);
            await dispatch(getSupplierInvoiceListApi({ type: 'all' }, [supplierId]));
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (supplierId) {
            fetchSupplierInvoice();
        }
    }, [supplierId]);

    if (isLoading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: 350 }}>
                <CircularProgress />
            </Grid>
        );
    }

    if (!supplierInvoiceList.length) return null;

    return (
        <Grid container spacing={3}>
            {supplierInvoiceList.map((invoice) => {
                const { _id, supplierInvoiceDate, partsOrderedDate, partsReceivedDate, invoiceNumber, parts, totalAmount, paymentTerms, draft, paymentStatus } =
                    invoice;

                const navigateUrl = draft
                    ? `/suppliers-invoice/draft/${_id}`
                    : `/suppliers-invoice/${paymentStatus === 'paid_in_full' ? 'paid' : paymentStatus === 'partial_payment' ? 'partial' : 'open'}/${_id}`;

                return (
                    <Grid item xs={12} sm={12} md={6} lg={12} xl={6} key={_id}>
                        <SupplierInvoiceCards
                            activeTab="supplierInvoice"
                            date={supplierInvoiceDate ? dayjs(supplierInvoiceDate).format('MMM DD, YYYY') : ''}
                            orderData={partsOrderedDate ? dayjs(partsOrderedDate).format('MMM DD, YYYY') : ''}
                            receivedDate={partsReceivedDate ? dayjs(partsReceivedDate).format('MMM DD, YYYY') : ''}
                            chipNumber={invoiceNumber || ''}
                            totalParts={parts?.length > 0 ? `${parts?.length} Parts` : '0 Part'}
                            amount={totalAmount ? formatCurrency(totalAmount) : '$0'}
                            creditDays={paymentTerms === 'none' ? 'None' : paymentTerms || ''}
                            navigate={navigate}
                            navigateUrl={navigateUrl}
                            paymentStatus={paymentStatus}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );
}

export default SupplierInvoiceTab;
